import { Controller } from "@hotwired/stimulus";
import bootstrap from "bootstrap/dist/js/bootstrap";

export default class extends Controller {
  static targets = ["partialToUpdate", "modal", "table"];
  static values = {
    resourceName: String,
  };

  connect() {
    this.destroyExistingDataTable();
    this.initializeDataTable();
  }

  updateHtml(event) {
    const [_data, _status, xhr] = event.detail;
    this.partialToUpdateTarget.innerHTML = xhr.response;
  }

  initializeDataTable() {
    try {
      const table = this.tableTarget;

      if (!table) {
        console.warn("Table target not found");
        return;
      }

      const order =
        this.tableTarget.dataset.sortColumnValue &&
        this.tableTarget.dataset.sortDirectionValue
          ? [
              [
                this.tableTarget.dataset.sortColumnValue,
                this.tableTarget.dataset.sortDirectionValue,
              ],
            ]
          : [];

      const config = {
        paging: this.tableTarget.dataset.pagingValue,
        pageLength: this.tableTarget.dataset.pageLengthValue || 100,
        searching: this.tableTarget.dataset.searchingValue,
        ordering: this.tableTarget.dataset.orderingValue,
        info: this.tableTarget.dataset.infoValue,
        stateSave: this.tableTarget.dataset.stateSaveValue,
        order: order,
      };

      $(table).DataTable(config);
    } catch (error) {
      console.error(`Error initializing DataTable:`, error);
    }
  }

  destroyExistingDataTable() {
    try {
      const table = this.tableTarget;
      if ($.fn.DataTable.isDataTable(table)) {
        $(table).DataTable().destroy();
      }
    } catch (error) {
      console.error("Error destroying DataTable:", error);
    }
  }

  openModal(event) {
    const modal = bootstrap.Modal.getOrCreateInstance(this.modalTarget);

    if (modal) {
      modal.show();
    }
    this.updateHtml(event);
  }

  closeModal() {
    const modal = bootstrap.Modal.getInstance(this.modalTarget);
    if (modal) {
      modal.hide();
    }
  }

  processResponseRow(responseHtml) {
    const tempTable = document.createElement("table");
    tempTable.innerHTML = responseHtml;
    return tempTable.querySelector("tr");
  }

  updateTable(event) {
    const [_data, _status, xhr] = event.detail;
    const newRow = this.processResponseRow(xhr.response);
    if (!newRow) return;

    const rowId = newRow.id;
    const existingRow = document.getElementById(rowId);

    try {
      this.destroyExistingDataTable();

      if (existingRow) {
        existingRow.innerHTML = newRow.innerHTML;
      } else {
        const tableBody = this.tableTarget.querySelector("tbody");
        if (tableBody) {
          tableBody.insertBefore(newRow, tableBody.firstChild);
          this.updateCountBadge(1);
        }
      }

      this.initializeDataTable();
    } catch (error) {
      console.error("Error updating table:", error);
      if (existingRow) {
        existingRow.outerHTML = newRow.outerHTML;
      } else {
        const tableBody = this.tableTarget.querySelector("tbody");
        if (tableBody) {
          tableBody.insertBefore(newRow, tableBody.firstChild);
        }
      }
    }

    this.closeModal();
  }

  appendRow(event) {
    const [_data, _status, xhr] = event.detail;
    const newRow = this.processResponseRow(xhr.response);

    try {
      this.destroyExistingDataTable();

      const tableBody = this.tableTarget.querySelector("tbody");
      if (tableBody) {
        tableBody.insertBefore(newRow, tableBody.firstElementChild);
        this.updateCountBadge(1);
      }

      this.initializeDataTable();
    } catch (error) {
      console.error("Error appending row:", error);
      const tableBody = this.tableTarget.querySelector("tbody");
      if (tableBody) {
        tableBody.insertBefore(newRow, tableBody.firstElementChild);
      }
    }

    this.closeModal();
  }

  updateCountBadge(change) {
    const countBadge = document.querySelector(".badge.bg-primary.rounded-pill");
    if (countBadge) {
      const currentCount = parseInt(countBadge.textContent.trim());
      if (!isNaN(currentCount)) {
        countBadge.textContent = (currentCount + change).toString();
      }
    }
  }
}
